export const VehicleFeatures = {
  props: [
    'categories',
  ],
  mounted() {
    // capture phase, so clicks stopped by other toggles' @click.stop still close this section
    this.outsideClick = (e) => {
      if (!this.$el.contains(e.target)) this.$emit('closeAllExcept', null);
    };
    document.addEventListener('click', this.outsideClick, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.outsideClick, true);
  },
  methods: {
    toggleWasOpened(who){
      this.$emit('closeAllExcept', who);
    }
  }
}